import { render } from "./tm-receive-success-popup.vue?vue&type=template&id=4e45bac0&scoped=true&ts=true"
import script from "./tm-receive-success-popup.vue?vue&type=script&lang=ts"
export * from "./tm-receive-success-popup.vue?vue&type=script&lang=ts"

import "./tm-receive-success-popup.vue?vue&type=style&index=0&id=4e45bac0&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e45bac0"]])

export default __exports__